import { useTranslation } from "react-i18next";
import { X, Book, MapPin } from "lucide-react";
import { ThemaCode, ThemaCodeType } from "reedy-data/api";
import { Badge } from "~/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";
import { Text } from "~/components/text";

export const ThemaCodesSearchControlsSelectionDisplay = ({
  selected,
  onRemove,
}: {
  selected: ThemaCode[];
  onRemove: (code: ThemaCode) => void;
}) => {
  const { t } = useTranslation("components");

  return (
    <div className="flex-1 border-dashed border border-secondary-300 rounded-md p-2 bg-white overflow-hidden">
      {selected.length === 0 ? (
        <Text as="span" variant="subtleItalic">
          {t("components:themaCodes.noSelection")}
        </Text>
      ) : (
        <div className="flex items-center gap-2 overflow-x-auto h-full">
          {selected.map((item) => (
            <Tooltip key={item.id}>
              <TooltipTrigger asChild>
                <Badge
                  variant="secondary"
                  className="group inline-flex items-center gap-1 min-w-0! shrink-0 px-2 py-1 font-mono cursor-pointer hover:bg-secondary-100"
                  onClick={() => onRemove(item)}
                >
                  {item.type === ThemaCodeType.SUBJECT ? (
                    <Book className="w-4 h-4" />
                  ) : (
                    <MapPin className="w-4 h-4" />
                  )}
                  {item.code}
                  <X className="w-3 h-3 ml-1 hidden group-hover:inline" />
                </Badge>
              </TooltipTrigger>
              <TooltipContent>
                {item.type === ThemaCodeType.SUBJECT
                  ? t("components:themaCodes.tooltips.subject")
                  : t("components:themaCodes.tooltips.qualifier")}
              </TooltipContent>
            </Tooltip>
          ))}
        </div>
      )}
    </div>
  );
};
